var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"premium-container"},[_c('dataTop'),_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.name)+"-成交溢价情况")])]),_c('div',{staticClass:"container flex-x"},[_c('aside-info'),_c('list-info')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }